









import VueOptions from '@utils/VueOptions'
import Modal from './Modal'
import RequestButton from '@/components/RequestButton'

settings =
  name: 'ActionModal'
  vue:
    components: { Modal, RequestButton }
    props: ['prompt']
    methods:
      closePrompt: -> @prompt.show = false
      hiHandler: ->
        @prompt.button.handler()

export default VueOptions.vue settings
